const config = document.getElementById('google-merchant-widget-config')
const merchantId = Number(config?.dataset.merchantId)
const widgetUrl = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js'

// The Google & YouTube app owns initialization when its embed is present.
if (
	config &&
	Number.isSafeInteger(merchantId) &&
	merchantId > 0 &&
	!window.merchantwidget &&
	!document.querySelector(`script[src="${widgetUrl}"]`)
) {
	const script = document.createElement('script')
	script.id = 'merchantWidgetScript'
	script.src = widgetUrl
	script.async = true
	script.addEventListener(
		'load',
		() => {
			if (document.getElementById('google-merchantwidget-iframe-wrapper')) return
			window.merchantwidget.start({
				merchant_id: merchantId,
				region: config.dataset.region,
				position: config.dataset.position === 'RIGHT_BOTTOM' ? 'RIGHT_BOTTOM' : 'LEFT_BOTTOM',
			})
		},
		{ once: true },
	)
	script.addEventListener(
		'error',
		() => {
			console.warn('Google store widget unavailable; the footer reviews link remains available.')
		},
		{ once: true },
	)
	document.head.appendChild(script)
}
